export default __webpack_public_path__ + "static/media/checkbox-checked.b51d6c06.svg";